import axios from 'axios';
import store from '../store';
import router from "../router";

class AdRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getAllAds() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/ads/active`,{headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new AdRepository();
